/** SCR-13 エラー画面 / SCR-14 規約・ポリシー（UI/UX設計書 §16） */
import { Link, useParams, useRouteError } from "react-router-dom";
import { Button } from "../components/ui";

export function ErrorPage({ status, message }: { status?: number; message?: string }) {
  const routeError = useRouteError() as { status?: number; statusText?: string } | undefined;
  const code = status ?? routeError?.status ?? 404;
  const text = message ?? {
    403: "この操作を行う権限がありません",
    404: "お探しのページは見つかりませんでした",
    503: "ただいまメンテナンス中です",
  }[code] ?? routeError?.statusText ?? "エラーが発生しました";

  return (
    <div className="container" style={{ maxWidth: 560, textAlign: "center", padding: "var(--space-8) var(--space-5)" }}>
      <p className="price" style={{ color: "var(--color-primary)" }}>{code}</p>
      <h1>{text}</h1>
      <div className="row" style={{ justifyContent: "center", marginTop: "var(--space-5)" }}>
        <Link to="/" className="btn btn--primary">トップへ戻る</Link>
        <Button variant="secondary" onClick={() => location.reload()}>再試行</Button>
        <Link to="/legal/contact" className="btn btn--ghost">お問い合わせ</Link>
      </div>
    </div>
  );
}

const LEGAL: Record<string, { title: string; body: string }> = {
  terms: {
    title: "利用規約",
    body: `第1条（適用）\n本規約は、V-Mall（以下「本サービス」）の利用に関する条件を定めるものです。\n\n第2条（アカウント）\n利用者は、登録情報を正確に保持し、パスワードを第三者に開示してはなりません。\n\n第3条（禁止事項）\n法令違反、他の利用者への迷惑行為、システムへの不正アクセス等を禁じます。\n\n第4条（免責）\n本サービスはローカル開発環境として提供されており、実際の取引は発生しません。`,
  },
  privacy: {
    title: "プライバシーポリシー",
    body: `1. 取得する情報\nメールアドレス、氏名、住所、電話番号、購入履歴、仮想空間内の位置情報を取得します。\n\n2. 利用目的\n本人確認、商品の配送、注文・配送に関する連絡、サービス改善のために利用します。\n\n3. 保管\n氏名・住所・電話番号・メールアドレスは暗号化して保管し、保持期間を限定します。\n\n4. 第三者提供\n決済ゲートウェイおよび配送事業者を除き、本人の同意なく第三者へ提供しません。`,
  },
  tokushoho: {
    title: "特定商取引法に基づく表記",
    body: `販売業者：V-Mall 運営事務局（ローカル開発環境）\n運営責任者：—\n所在地：—\n連絡先：no-reply@v-mall.jp\n販売価格：各商品ページに表示された価格（税込）\n商品代金以外の必要料金：送料（10,000円以上のご購入で無料）\n支払方法：クレジットカード / コンビニ払い / ウォレット\n引渡時期：ご注文確定後、5 営業日以内に発送\n返品・交換：商品到着後 7 日以内にご連絡ください`,
  },
  contact: {
    title: "お問い合わせ",
    body: `本サイトはローカル開発環境です。\n不具合のご報告や機能に関するご要望は、開発チームまでお知らせください。\n\nメール：support@v-mall.jp\n受付時間：平日 10:00 - 18:00`,
  },
};

export function LegalPage() {
  const { doc } = useParams();
  const entry = LEGAL[doc ?? "terms"];
  if (!entry) return <ErrorPage status={404} />;
  return (
    <div className="container" style={{ maxWidth: 760 }}>
      <h1>{entry.title}</h1>
      <div className="card"><div className="card__body">
        <p style={{ whiteSpace: "pre-wrap", margin: 0, lineHeight: 1.9 }}>{entry.body}</p>
      </div></div>
    </div>
  );
}
